exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{height:100vh;color:#fff}body,body p{font-family:DNB Fedra Light,Sans-Serif;font-variant-numeric:lining-nums}body p{font-size:16px;line-height:23px}@media (max-width:575.98px){body p{font-size:14px;line-height:20px}}body h2{font-family:DNB Fedra Book,Sans-Serif;font-variant-numeric:lining-nums;font-size:24px;line-height:30px;margin-bottom:12px}@media (max-width:575.98px){body h2{font-size:20px;line-height:26px}}body h3{font-family:DNB Fedra Book,Sans-Serif;font-variant-numeric:lining-nums;font-size:20px;line-height:24px}@media (max-width:575.98px){body h3{font-size:17px;line-height:21px}}body a{font-family:DNB Fedra Light,Sans-Serif;font-variant-numeric:lining-nums;color:#9994c2}body a:hover{text-decoration:none}body a:hover:hover{color:hsla(0,0%,100%,.75)}body strong{font-family:DNB Fedra Medium,Sans-Serif;font-variant-numeric:lining-nums}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7567fd58","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 219
// module chunks = 0